module.exports = __webpack_public_path__ + "img/cool.1787fa25.gif";